<template>
      <div no-body class="lkuBankCash"> 
      <b-row>
        <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend><span class="pt-2 mr-3">Filter</span></b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblCoa"
          responsive
          striped hover
          :items="items"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc" 
          :key="tblData.page"
          :filter="filter"
          @filtered="onFiltered"                
          @row-clicked="selectItem"
        >
        <template v-slot:cell(nomor)="data">
          {{ (tblData.page - 1) * tblData.limit + (data.index + 1)}}
        </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lkuBankCash {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import bankcashacc from "../../apis/bankcashacc";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      updatetable:false,
      fields: [
        {
          key: "namabank",
          label: "Account Name",
          sortable: true
        },
        {
          key: "matauang",
          thStyle: "width:40px",
          label: "Rp,$,¥",
          sortable: true
        },
        {
          key: "nomorrek",
          label: "Nomor Rekening",
          sortable: true
        },
        {
          key: "cabang",
          label: "Cabang",
          sortable: true
        },
        {
          key: "kodeacc",
          label: "GL Account",
          sortable: true
        },
        {
          key: "aktif",
          label: "Active",
          thStyle: "width:40px",
          sortable: true
        },
      ],
      items:[],
      tblData: {
        page: 1,
        limit:10000,
        total: 0,
        sortBy: 'namabank',
        sortDesc: false,aktif:'1'
      },
      filter:null
    };
  },
  created: async function() {
      this.data();
  },
  mounted() {
    // Set the initial number of items
    this.tblData.total = this.items.length;
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    data: async function(ctx) {
      this.tblData.limit=10000;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      // this.items=await crud.list(this.tblData);
      // return this.items;      
      this.lkuLoading=true;
      const list = await bankcashacc.list(this.tblData);      
      this.lkuLoading=false;
      this.items=list;
      this.tblData.limit= 20;
      this.updatetable=!this.updatetable;
    },
    selectItem(item,index) {
        // const idxChg = this.items.findIndex((rec)=>{
        //                 return (rec.kodegroup.startsWith(item.kodegroup) && (rec.kodegroup !==item.kodegroup));
        //             })
        // if ((idxChg || -1) > -1) {
        //   console.log ('Account punya anak tidak boleh dipilih');
        //     toastr.warn('Account punya anak tidak boleh dipilih!');
        // } else {
        this.$emit("click", item);
        // }
    },  
    refresh() {
      this.$refs.tblCoa.refresh();
    }
  }
};
</script>
